// Generated using typescript-generator version 3.2.1263 on 2026-06-26 15:40:43.

/**
 * Account editor specific data
 */
export interface AccountEditorData {
  acctSchemaId?: number;
  elementType?: string;
  hasAlias?: string;
  seqNo?: number;
}

export interface AdvancedSearchDocument {
    _id?: string;
    arkhineoTask?: ArkhineoScheduledTask;
    docId?: string;
    fileName?: string;
    hasError?: boolean;
    id?: string;
    provider?: string;
    record_id?: string;
    table_id?: string;
    tags?: Map<string, any>;
    type?: string;
    ufa_created_date?: string;
    ufa_local_path?: string;
    ufa_secret_token?: string;
    ufa_updated_date?: string;
    url?: string;
}

export interface ApizColumnKanban {
  dataAlignLeft?: string[];
  dataAlignright?: string[];
}

export interface ApizField {
  details?: ApizFieldLookup;
  field?: ApizFieldData;
  urlCallouts?: string;
  urlList?: string;
  urlSearch?: string;
}

export interface ApizFieldComputed {
  children?: any[];
  columnId?: number;
  component?: string;
  cssClass?: string;
  data?: ApizUIDataField;
  displayLength?: number;
  fieldGroup?: string;
  fieldId?: number;
  formDetailId?: number;
  formDetailItemId?: number;
  formId?: number;
  isCallout?: boolean;
  isRange?: boolean;
  isReadOnly?: boolean;
  processId?: number;
  referenceId?: number;
  seqNo?: number;
  tableId?: number;
}

export interface ApizFieldData {
  ad_Column_ID?: number;
  ad_Field_ID?: number;
  ad_Form_ID?: number;
  ad_JsonDef_ID?: number;
  ad_Process_ID?: number;
  ad_Reference_ID?: number;
  ad_Reference_Value_ID?: number;
  ad_Tab_ID?: number;
  ad_Table_ID?: number;
  ad_UserDef_Field_ID?: number;
  ad_UserDef_Tab_ID?: number;
  ad_UserDef_Win_ID?: number;
  ad_User_ID?: number;
  ad_Val_Rule_ID?: number;
  ad_Window_ID?: number;
  callout?: string;
  colNo?: string;
  colspanEdit?: number;
  columnName?: string;
  columnSQL?: string;
  customizationName?: string;
  defaultValue?: string;
  defaultValue2?: string;
  description?: string;
  displayKanban?: string;
  displayLength?: number;
  displayLogic?: string;
  fieldGroup?: string;
  fieldGroupDisplayLogic?: string;
  fieldGroupExpanded?: boolean;
  fieldGroupExpandedLogic?: string;
  fieldLength?: number;
  fieldReadOnlyLogic?: string;
  help?: string;
  isAlwaysUpdateable?: boolean;
  isAnonymized?: boolean;
  isBaseCurrency?: boolean;
  isButtonReadOnly?: boolean;
  isCallout?: boolean;
  isCopy?: boolean;
  isDefaultFocus?: boolean;
  isDisplayReduceGrid?: boolean;
  isDisplayed?: boolean;
  isEncryptedColumn?: boolean;
  isEncryptedField?: boolean;
  isFieldOnly?: boolean;
  isFileNew?: boolean;
  isHeading?: boolean;
  isIdentifier?: boolean;
  isKey?: boolean;
  isMandatory?: boolean;
  isMandatoryUI?: boolean;
  isParent?: boolean;
  isRange?: boolean;
  isReadOnly?: boolean;
  isSameLine?: boolean;
  isSelectionColumn?: boolean;
  isSummaryColumn?: boolean;
  isTranslated?: boolean;
  isUpdateable?: boolean;
  mandatoryLogic?: string;
  maxHeight?: number;
  maxWidth?: number;
  mrseqNo?: number;
  name?: string;
  obscureType?: string;
  panel?: string;
  readOnlyLogic?: string;
  selectionSeqNo?: number;
  seqNo?: number;
  sortNo?: number;
  summarySeqNo?: number;
  tableName?: string;
  userDef_Role_ID?: number;
  validationCode?: string;
  valueMax?: number;
  valueMin?: number;
  vformat?: string;
}

export interface ApizFieldLookup {
  autoCompletionFromClause?: string;
  columName?: string;
  cssColor?: Record<string, string>;
  entityID?: number;
  entityType?: number;
  keyColumn?: string;
  sqlDisplayData?: string;
  tableName?: string;
}

export interface ApizJsonDef {
  fields?: ApizJsonField[];
  hasMultiValues?: boolean;
  jsonDefId?: number;
  name?: string;
}

export interface ApizJsonField {
  componentName?: string;
  description?: string;
  isDisplayed?: boolean;
  isKey?: boolean;
  jsonDefId?: number;
  jsonFieldId?: number;
  name?: string;
  nameToShow?: string;
  numberType?: NumberType;
  seqNo?: number;
}

export interface ApizStepperData {
  docActionField?: ApizUIField;
  docStatusField?: ApizUIField;
}

export interface ApizTableDataHeader {
  AD_Reference_ID?: number;
  alwaysEditable?: boolean;
  cellEditor?: any;
  cellEditorParams?: any;
  cellRenderer?: any;
  cellRendererParams?: any;
  checkboxSelection?: any;
  cssColors?: Record<string, string>;
  editable?: boolean;
  enableCellChangeFlash?: boolean;
  enablePivot?: boolean;
  enableRowGroup?: boolean;
  enableValue?: boolean;
  field?: string;
  filter?: string;
  filterParams?: any;
  headerComponent?: any;
  headerComponentParams?: any;
  headerName?: string;
  hide?: boolean;
  maxWidth?: number;
  resizable?: boolean;
  rowGroup?: boolean;
  sortable?: boolean;
  suppressMenu?: boolean;
  width?: number;
}

export interface ApizUIDataField {
  colNo?: number;
  colspan?: number;
  columnId?: number;
  columnName?: string;
  componentName?: string;
  defaultValue?: string;
  defaultValue2?: string;
  description?: string;
  detailZoom?: ApizUIZoomInfo;
  details?: ApizFieldLookup;
  displayKanban?: string;
  displayLogic?: string;
  fieldId?: number;
  fieldType?: string;
  formId?: number;
  fromRange?: boolean;
  hasValidation?: boolean;
  help?: string;
  isAccount?: boolean;
  isAlwaysUpdatable?: boolean;
  isAnonymized?: boolean;
  isButtonReadOnly?: boolean;
  isCollapsedDefault?: boolean;
  isCopy?: boolean;
  isDisplayed?: boolean;
  isFieldOnly?: boolean;
  isMandatory?: boolean;
  isParam?: boolean;
  isSameLine?: boolean;
  isSearch?: boolean;
  isSelected?: boolean;
  isUpdateable?: boolean;
  jsonDefId?: number;
  label?: string;
  lineNo?: number;
  mandatoryLogic?: string;
  nbCol?: number;
  nbrAddressSlot?: number;
  needTime?: boolean;
  numberType?: NumberType;
  processId?: number;
  query?: any;
  readOnlyLogic?: string;
  recordID?: number;
  referenceID?: number;
  searchColumns?: any[];
  tabId?: number;
  tableName?: string;
  urlCallouts?: string;
  urlList?: string;
  urlSearch?: string;
  validationCode?: string;
  vformat?: string;
}

export interface ApizUIEditTab extends ApizUIItemGroup<ApizUIItem> {
  children?: ApizUIItem[];
  data?: ApizUIEditTabData;
  key?: string;
  tabChildren?: number[];
  tabId?: number;
}

export interface ApizUIEditTabData {
  AD_ColumnSortOrder_ID?: number;
  AD_ColumnSortYesNo_ID?: number;
  AD_FormDetail_ID?: number;
  AD_Form_ID?: number;
  AD_Tab_ID?: number;
  AD_Table_ID?: number;
  AD_Window_ID?: number;
  colNo?: number;
  colspan?: number;
  columnId?: number;
  columnName?: string;
  columnsDisplayAD?: ApizColumnKanban[];
  columnsReduceGrid?: string[];
  columnsTableHeader?: ApizTableDataHeader[];
  componentName?: string;
  cssClass?: string;
  ctxArea?: Record<string, any>;
  defaultValue?: string;
  defaultValue2?: string;
  description?: string;
  displayLogic?: string;
  docFilters?: string;
  editData?: EditData;
  fileOpening?: boolean;
  fileOpeningFilters?: string;
  gridData?: GridData;
  gridPaginator?: boolean;
  gridTabFilter?: string[];
  gridTabValidator?: string;
  hasTree?: boolean;
  help?: string;
  isAccount?: boolean;
  isAdditionalInfo?: boolean;
  isAlwaysUpdatable?: boolean;
  isCollapsable?: boolean;
  isCollapsedDefault?: boolean;
  isDeletable?: boolean;
  isDeletableLogic?: string;
  isDisplayed?: boolean;
  isDocumentTab?: boolean;
  isHighVolume?: boolean;
  isInsertRecord?: boolean;
  isReadOnly?: boolean;
  isSAE?: boolean;
  isSameLine?: boolean;
  isSearch?: boolean;
  isSelected?: boolean;
  isSingleRow?: boolean;
  isSortTab?: boolean;
  isTabTopLevel?: boolean;
  isUpdateable?: boolean;
  isView?: boolean;
  items?: any[];
  kanbanImageColumn?: string;
  label?: string;
  lineNo?: number;
  maxNbLines?: number;
  nbCol?: number;
  nbrAddressSlot?: number;
  poLabel?: string;
  readOnlyLogic?: string;
  seqNo?: number;
  stepperData?: ApizStepperData;
  tabId?: number;
  tabLevel?: number;
  tabType?: string;
  tableName?: string;
  taggedColumns?: string;
  urlTree?: string;
  workflow?: ApizWorkFlow;
}

export interface ApizUIField extends ApizUIItem {
  columnId?: number;
  cssClass?: string;
  data?: ApizUIDataField;
  displayLength?: number;
  fieldGroup?: string;
  fieldId?: number;
  formDetailId?: number;
  formDetailItemId?: number;
  formId?: number;
  isCallout?: boolean;
  isRange?: boolean;
  processId?: number;
  referenceId?: number;
  tableId?: number;
}

export interface ApizUIFieldEntity {
  details?: ApizFieldLookup;
  field?: Record<string, any>;
  poName?: string;
  urlCallouts?: string;
  urlList?: string;
  urlSearch?: string;
}

export interface ApizUIFieldGroup extends ApizUIItemGroup<ApizUIField> {
  children?: ApizUIField[];
  data?: ApizUIDataField;
}

export interface ApizUIForm {
  AD_Client_ID?: number;
  AD_CtxArea_ID?: number;
  AD_FormDetail_ID?: number;
  AD_Form_ID?: number;
  AD_Org_ID?: number;
  AccessLevel?: string;
  AngularClass?: string;
  Classname?: string;
  Description?: string;
  EntityType?: string;
  Help?: string;
  IsActive?: boolean;
  IsBetaFunctionality?: boolean;
  Name?: string;
  WebClassname?: string;
  detail?: ApizUIFormDetail;
}

export interface ApizUIFormDetail {
  AD_Client_ID?: number;
  AD_FormDetail_ID?: number;
  AD_InfoWindow_ID?: number;
  AD_Org_ID?: number;
  AD_Table_ID?: number;
  EntityType?: string;
  IsActive?: boolean;
  Name?: string;
  Processing?: boolean;
  Titre?: string;
  Type?: string;
  Value?: string;
  items?: ApizUIFormDetailItem[];
  locationDisplaySequence?: string;
  maxNbLines?: number;
}

export interface ApizUIFormDetailItem {
  AD_Client_ID?: number;
  AD_Element_ID?: number;
  AD_FormDetailChild_ID?: number;
  AD_FormDetailItem_ID?: number;
  AD_FormDetail_ID?: number;
  AD_Form_ID?: number;
  AD_JsonDef_ID?: number;
  AD_Org_ID?: number;
  AD_Process_ID?: number;
  AD_Reference_ID?: number;
  AD_Reference_Value_ID?: number;
  AD_Val_Rule_ID?: number;
  ColumnName?: string;
  Created?: Date;
  CreatedBy?: number;
  CssClass?: string;
  DefaultValue?: string;
  Description?: string;
  DisplayLogic?: string;
  EntityType?: string;
  ExtendedLogic?: string;
  FilterName?: string;
  Help?: string;
  IsActive?: boolean;
  IsColumnSQL?: boolean;
  IsEditable?: boolean;
  IsExtendedFilter?: boolean;
  IsFrontEnd?: boolean;
  IsLaunchSearchGrid?: boolean;
  IsMandatory?: boolean;
  IsNextLine?: boolean;
  IsOptional?: boolean;
  IsRange?: boolean;
  IsSelectionColumn?: boolean;
  MandatoryLogic?: string;
  Name?: string;
  ReadOnlyLogic?: string;
  SeqNo?: number;
  Updated?: Date;
  UpdatedBy?: number;
  detail?: ApizUIFormDetail;
  field?: ApizUIFieldEntity;
  hasCheckbox?: boolean;
  hasExtendedLogic?: boolean;
  hasUniversalFilter?: boolean;
}

export interface ApizUIItem {
  component?: string;
  isReadOnly?: boolean;
  seqNo?: number;
}

export interface ApizUIItemGroup<UIItem> extends ApizUIItem {
  children?: UIItem[];
}

export interface ApizUIProcess extends ApizUIItemGroup<ApizUIItem> {
  children?: ApizUIItem[];
  fields?: ApizUIField[];
  fileFormats?: AutocompleteVO[];
  hasFormat: boolean;
  hasJasper: boolean;
  isReport: boolean;
  printFormats?: PrintFormatAutocompleteVO[];
  process: ApizUIProcessInfo;
}

export interface ApizUIProcessInfo {
  AD_BView_ID?: number;
  AD_PInstance_ID?: number;
  AD_Process_ID?: number;
  AD_ReportTemplate_ID?: number;
  AD_ReportView_ID?: number;
  AD_Workflow_ID?: number;
  ClassName?: string;
  DashboardType?: string;
  DataLabel?: string;
  DataPoint?: string;
  Description?: string;
  FileName?: string;
  Form?: string;
  Help?: string;
  IDs?: number[];
  IsDashboard?: boolean;
  IsDirectPrint?: boolean;
  IsReport: boolean;
  IsSOTrx?: boolean;
  IsServerProcess?: boolean;
  Name: string;
  ProcedureName?: string;
  QueryVo?: ApizUIQuery;
  Style?: string;
  Summary?: string;
  ZoomWindow_ID?: number;
  files?: string[];
  isDirectZoom?: boolean;
  isError?: boolean;
  logInfo?: string;
  nbCol: number;
  shouldOpenLogs: boolean;
}

export interface ApizUIQuery {
  onlyCurrentCreated?: boolean;
  onlyCurrentDays?: number;
  restrictions?: ApizUIQueryRestriction[];
  saveQuery?: boolean;
  savedQueryName?: string;
  textQuery?: string;
  textSearch?: boolean;
}

export interface ApizUIQueryRestriction {
  andCondition?: boolean;
  code?: string;
  code_to?: string;
  columnName?: string;
  directWhereClause?: string;
  displayType?: number;
  infoDisplay?: string;
  infoDisplay_to?: string;
  infoName?: string;
  operator?: string;
}

export interface ApizUIWindow {
  columnInfos?: ApizUIWindowColumnInfo[];
  data?: ApizUIWindowData;
  datastructures?: Record<string, Record<string, any>>;
  forms?: ApizUIForm[];
  jsonDefs?: ApizJsonDef[];
  processes?: ApizUIProcess[];
  tabs?: Record<string, ApizUIEditTab>;
}

export interface ApizUIWindowColumnInfo {
  adTabId?: number;
  columnInfo?: ApizUIWindowColumnInfoDef[];
}

export interface ApizUIWindowColumnInfoDef {
  fieldEntity?: ApizUIFieldEntity;
  filterType?: string;
}

export interface ApizUIWindowData {
  AD_Client_ID?: number;
  AD_CtxArea_ID?: number;
  AD_Image_ID?: number;
  AD_Org_ID?: number;
  AD_Window_ID?: number;
  Description?: string;
  Help?: string;
  IsActive?: boolean;
  IsCustomDefault?: boolean;
  IsDefault?: boolean;
  IsElastics?: boolean;
  IsReadWrite?: boolean;
  Name?: string;
  Value?: string;
  WinHeight?: number;
  WinWidth?: number;
  WindowType?: string;
  icon?: string;
}

export interface ApizUIZoomInfo {
  children?: any;
  columnKey?: string;
  dataUUID?: string;
  isInCurrentWindow?: boolean;
  parentId?: string;
  recordId?: number;
  tableName?: string;
  windowId?: number;
}

export interface ApizWFNextStatus {
  AD_Client_ID?: number;
  AD_Org_ID?: number;
  AD_WF_Next_ID?: number;
  AD_WF_NodeNext_ID?: number;
  AD_WF_Node_ID?: number;
  Description?: string;
  IsActive?: boolean;
  IsStartNoeud?: boolean;
  IsStdUserWorkflow?: boolean;
  Name?: string;
  SeqNo?: number;
}

export interface ApizWFStatus {
  AD_WF_Node_ID?: number;
  AD_Workflow_ID?: number;
  Action?: ApizWFStatusAction;
  Description?: string;
  DocAction?: string;
  IsActive?: boolean;
  IsCentrallyMaintained?: boolean;
  Name?: string;
  Nexts?: ApizWFNextStatus[];
  Value?: string;
  isStartNoeud?: boolean;
}

export interface ApizWFStatusAction {
  AD_Client_ID?: number;
  AD_Org_ID?: number;
  AD_Ref_List_ID?: number;
  AD_Reference_ID?: number;
  Code?: string;
  Description?: string;
  IsActive?: boolean;
  Name?: string;
  Value?: string;
}

export interface ApizWorkFlow {
  AD_Client_ID?: number;
  AD_Process_ID?: number;
  AD_Table_ID?: number;
  AD_WF_Node_ID?: number;
  AD_Workflow_ID?: number;
  AccessLevel?: string;
  Description?: string;
  IsActive?: boolean;
  IsValid?: boolean;
  Name?: string;
  Nodes?: ApizWFStatus[];
  PublishStatus?: string;
}

export interface ArkhineoScheduledTask {
    createdAt?: Date;
    docid?: string;
    errorMessage?: string;
    id?: string;
    instanceId?: string;
    lastAttemptAt?: Date;
    lockedAt?: Date;
    nextAttemptAt?: Date;
    retryCount?: number;
    status?: ArkhineoTaskStatus;
    updatedAt?: Date;
}

export interface AutocompleteVO {
  displayValue: string;
  id: any;
  model?: any;
}

/**
 * BPartner Balance specific data
 */
export interface BPartnerBalanceData {
  accountId?: number;
  isCustomer?: string;
  isVendor?: string;
  partnerId?: number;
}

/**
 * Badge button data for customer-360 quick indicators
 */
export interface BadgeButtonData {
  action?: string;
  hasIcon?: boolean;
  label?: string;
  rule?: number;
  value?: any;
}

/**
 * Badge data structure
 */
export interface BadgeData {
  label?: string;
  rule?: number;
  value?: number;
}

export interface BankData {
  accountNo?: string;
  bankAccountId?: number;
  iban?: string;
  partnerId?: number;
  qr_IBAN?: string;
  xx_REFERENCE?: string;
}

export interface BatchFieldStateRequest {
  fieldIds: number[];
  states: ItemStateType[];
  windowCtx: Record<string, any>;
}

export interface BatchFieldStateResponse {
  errors?: Record<string, FieldStateError>;
  results?: Record<string, ItemState>;
}

export interface ChargeDescriptionData {
  c_Charge_ID?: number;
  description?: string;
  name?: string;
}

export interface ColumnFilter {
  configs?: any[];
  filterType?: FilterType;
  operators?: Operator[];
  values?: any[];
}

export interface ColumnVO {
  aggFunc?: AggFunc;
  displayName?: string;
  field?: string;
  id?: string;
}

/**
 * Count-based statistics structure
 */
export interface CountStatistics {
  amount?: number;
  count?: number;
  indicator?: string;
  label?: string;
  pct?: number;
}

export interface CountryData {
  countryCode?: string;
  countryId?: number;
  name?: string;
}

export interface CurrencyData {
  curSymbol?: string;
  currencyId?: number;
  description?: string;
  isocode?: string;
}

/**
 * Customer profile data for customer-360 view
 */
export interface CustomerProfileData {
  fullName?: string;
  id?: number;
  isForbidden?: boolean;
  lastRefresh?: string;
  profilePicture?: string;
  rating?: CustomerRating;
  top?: number;
  type?: string;
}

/**
 * Customer rating data
 */
export interface CustomerRating {
  value?: number;
}

export interface DataFieldRequest {
  entityId?: number;
  fromFilter?: boolean;
  query?: string;
  recordId?: string;
  validation?: string;
  windowType?: string;
}

export interface DataRequest {
  ad_language?: string;
  endRow?: number;
  filterModel?: Record<string, ColumnFilter>;
  groupKeys?: any[];
  headerCols?: ColumnVO[];
  rowGroupCols?: ColumnVO[];
  sortModel?: SortModel[];
  startRow?: number;
  validation?: string;
  valueCols?: ColumnVO[];
  windowCtx?: Record<string, any>;
}

export interface DocActionRequest {
  docAction?: string;
  docStatus?: string;
  isSOTrx?: string;
  orderType?: string;
  processing?: string;
  record_ID?: string;
  table_ID?: string;
  table_Name?: string;
  user_ID?: string;
}

export interface DocServerSimpleTag {
  name?: string;
  value?: any;
}

export interface DroolsBuildResponse {
  messages?: DroolsBuildResponseMessage[];
}

export interface DroolsBuildResponseMessage {
  column?: number;
  level?: string;
  line?: number;
  msg?: string;
  path?: string;
}

export interface DroolsFileManagementRequest {
  destination?: string;
  sources?: string[];
}

export interface DroolsNewFileRequest {
  destination?: string;
  type?: DroolsNewFileRequestType;
}

/**
 * Earnings statistics structure
 */
export interface EarningsStatistics {
  amount?: number;
  currency?: string;
  indicator?: string;
  label?: string;
  last?: number;
  pct?: number;
}

export interface EditData extends EditTabData {
  nbCol?: number;
}

export interface EditTabData {
  colNo?: number;
  colspan?: number;
  lineNo?: number;
}

export interface Email {
  ad_usermail_id?: number;
  body?: string;
  cc?: string[];
  cci?: string[];
  files?: FileEmail[];
  from?: string;
  r_mailtext_id?: number;
  r_request_id?: number;
  recordId?: number;
  subject?: string;
  tabId?: number;
  tableId?: number;
  to?: string[];
}

export interface FieldStateDebugInfo {
  evaluatedLogics?: Record<string, string>;
  evaluationTimeMs?: number;
  sqlQueries?: string[];
}

export interface FieldStateError {
  details?: Record<string, any>;
  error?: string;
  fieldId?: number;
  message?: string;
  stackTrace?: string;
  timestamp?: Date;
}

export interface FileDef {
  isDirectory?: boolean;
  path?: string;
}

export interface FileEmail {
  fileName?: string;
  url?: string;
}

export interface FileInfo {
  extension?: string;
  fileName?: string;
  path?: string;
}

export interface FilterParams {
  applyButton?: boolean;
  clearButton?: boolean;
  filterOptions?: string[];
  newRowsAction?: string;
}

export interface FormTableRowVO {
  columns?: Record<string, any>;
  record_ID?: number;
}

export interface FormTableVO {
  ad_FormDetail_ID?: number;
  rows?: FormTableRowVO[];
}

export interface GridData extends EditTabData {
}

export interface GridRowsRequest {
  ad_language?: string;
  basicCompiereRequest?: Record<string, any>;
  endRow?: number;
  entityId?: number;
  exportSelections?: Record<string, any>[];
  filterModel?: Record<string, ColumnFilter>;
  fromGrid?: boolean;
  groupKeys?: any[];
  headerCols?: ColumnVO[];
  parent_formDetail_id?: number;
  pivotCols?: ColumnVO[];
  pivotMode?: boolean;
  rowGroupCols?: ColumnVO[];
  searchEntityType?: number;
  searchKeyColumn?: string;
  sortModel?: SortModel[];
  startRow?: number;
  tableName?: string;
  validation?: string;
  valueCols?: ColumnVO[];
  windowCtx?: Record<string, any>;
  windowType?: WindowType;
}

export interface InvoiceData {
  currencyId?: number;
  dateInvoiced?: Date;
  docStatus?: string;
  documentNo?: string;
  grandTotal?: number;
  invoiceId?: number;
  partnerId?: number;
}

export interface InvoiceLineData {
  c_Charge_ID?: number;
  c_InvoiceLine_ID?: number;
  c_Invoice_ID?: number;
  c_Tax_ID?: number;
  description?: string;
  line?: number;
  lineNetAmt?: number;
  lineTotalAmt?: number;
  m_Product_ID?: number;
  priceActual?: number;
  priceEntered?: number;
  priceList?: number;
  qtyEntered?: number;
  taxAmt?: number;
}

export interface InvoiceTaxData {
  c_Invoice_ID?: number;
  c_Tax_ID?: number;
  taxAmt?: number;
  taxBaseAmt?: number;
  taxName?: string;
}

export interface ItemState {
  debug?: FieldStateDebugInfo;
  defaultValue?: any;
  displayed?: boolean;
  mandatory?: boolean;
  message?: string;
  readonly?: boolean;
  recordId?: number;
  requestedStates?: ItemStateType[];
}

export interface ItemStateBody {
  states: ItemStateType[];
  windowCtx: Record<string, any>;
}

export interface MessageData {
  msgText?: string;
  value?: string;
}

export interface NbRequestRequest {
  recordId: number;
  roleId: number;
  salesRepId: number;
  tableId: number;
}

export interface NextDocument {
  Description?: string;
  Name?: string;
  Value?: string;
}

export interface Notification {
  additionalProperties?: Record<string, any>;
  closed?: boolean;
  created?: Date;
  description?: string;
  fileLinks?: FileInfo[];
  isError?: boolean;
  notificationType?: string;
  priority?: string;
  processChannelId?: string;
  processParams?: Record<string, any>;
  request_id?: number;
  sourceRecordId?: string;
  sourceTableNameTargeted?: string;
  sourceType?: string;
  sourceTypeId?: number;
  summary?: string;
  target?: string;
  title?: string;
  type?: string;
  userName?: string;
  zoomInfo?: ZoomInfo;
}

export interface NotificationSocket {
  ad_role_id?: number;
  ad_user_id?: number;
  notification?: Notification;
}

export interface OrderData {
  c_BPartner_ID?: number;
  c_Order_ID?: number;
  dateOrdered?: Date;
  docStatus?: string;
  documentNo?: string;
  grandTotal?: number;
}

export interface PartnerData {
  c_BPartner_ID?: number;
  isActive?: string;
  isVendor?: string;
  name?: string;
  value?: string;
}

export interface PartnerLocationData {
  address1?: string;
  address2?: string;
  c_BPARTNER_LOCATION_ID?: number;
  c_BPartner_ID?: number;
  c_Location_ID?: number;
  city?: string;
  name?: string;
  postal?: string;
}

export interface PrintFormatAutocompleteVO extends AutocompleteVO {
  fileFormats?: AutocompleteVO[];
}

export interface ProcessRequest {
  ad_process_id?: number;
  ad_tab_id?: number;
  className?: string;
  params?: Record<string, any>;
  record_id?: number;
  tableName?: string;
  tables?: FormTableVO[];
  windowCtx?: Record<string, any>;
}

export interface ProcessResponse {
  error?: string;
  message?: string;
}

export interface ProductDescriptionData {
  description?: string;
  m_Product_ID?: number;
  name?: string;
  value?: string;
}

/**
 * Quick action data for customer-360 actions
 */
export interface QuickActionData {
  action?: string;
  label?: string;
  processId?: number;
  readonly?: boolean;
  subActions?: QuickActionSubData[];
  subActionsDataQuery?: SubActionsDataQuery;
  type?: QuickActionType;
}

/**
 * Sub-action data
 */
export interface QuickActionSubData {
  displayValue?: string;
  id?: any;
}

export interface RunWorkFlow {
  action?: string;
  ad_process_id?: string;
  record_id?: string;
  table_Name?: string;
  table_id?: string;
  windowCtx?: Record<string, any>;
}

export interface RunWorkflowResponse {
  completedAt?: Date;
  createdAt?: Date;
  message?: string;
  processed?: string;
  progress?: number;
  result?: Record<string, any>;
  status?: RunWorkflowStatus;
  success?: boolean;
  workflowId?: string;
}

export interface SDComponent {
  component: string;
  description: string;
  id: number;
  name: string;
  position?: SDPositionData;
}

export interface SDConfig {
  i18n: SDLanguages;
  inputs: SDComponent[];
  panels: SDConfigPanels;
}

export interface SDConfigPanels {
  field: ApizFieldComputed[];
  tab: ApizFieldComputed[];
  window: ApizFieldComputed[];
}

export interface SDField {
  component: string;
  data: SDFieldData;
  fields?: SDField[];
  id: string;
  position: SDPositionData;
  referenceId: number;
}

export interface SDFieldData {
  AD_Column_ID: AutocompleteVO;
  AD_FieldGroup_ID: AutocompleteVO;
  AD_Reference_ID: AutocompleteVO;
  ColNo: number;
  ColspanEdit: number;
  ColumnName: string;
  DefaultValue: string;
  Description: Record<string, string>;
  DisplayKanban: AutocompleteVO;
  DisplayLogic: string;
  FieldLength: number;
  Help: Record<string, string>;
  IsDisplayed: boolean;
  IsIdentifier: boolean;
  IsKey: boolean;
  IsMandatory: boolean;
  IsReadOnly: boolean;
  IsUpdateable: boolean;
  MandatoryLogic: string;
  Name: Record<string, string>;
  ReadOnlyLogic: string;
  SeqNo: number;
}

export interface SDLanguages {
  default: string;
  languages: string[];
}

export interface SDPositionData {
  span: number;
  x: number;
  y: number;
}

export interface SDRecentItem {
  icon?: string;
  id: number;
  lastUpdatedByMe?: boolean;
  myLastUpdated?: Date;
  name: string;
  updated: Date;
  updatedBy: number;
  updatedByDisplayValue: string;
}

export interface SDTab {
  description?: Record<string, string>;
  displayLogic?: string;
  fields: SDField[];
  help?: Record<string, string>;
  id: string;
  isAdditionnalTab?: boolean;
  isDisplayed?: boolean;
  isInsertRecord?: boolean;
  isReadonly?: boolean;
  name: Record<string, string>;
  nbCols: number;
  orderBy?: string;
  parentId?: string;
  position?: SDPositionData;
  readonlyLogic?: string;
  seqNo?: number;
  tabLevel?: number;
  tableId?: number;
  tabs?: SDTab[];
  where?: string;
}

export interface SDWindow {
  action: AutocompleteVO;
  description: Record<string, string>;
  entityType?: AutocompleteVO;
  icon?: string;
  id: number;
  isReadonly: boolean;
  isSummary: boolean;
  name: Record<string, string>;
  tabs: SDTab[];
}

export interface SDWindowEntry {
  ad_window_id?: string;
  icon?: string;
  language?: string;
  name?: string;
}

export interface SortModel {
  colId?: string;
  colName?: string;
  sort?: SortDirection;
}

/**
 * Statistics card data for customer-360 metrics
 */
export interface StatisticsCardData {
  amount?: number;
  count?: number;
  indicator?: string;
  label?: string;
  pct?: number;
  type?: StatisticsCardType;
}

/**
 * Query configuration for sub-actions
 */
export interface SubActionsDataQuery {
  columnName?: string;
  context?: Record<string, any>;
}

export interface TabData {
  ad_TABLE_ID?: number;
  ad_TAB_ID?: number;
  ad_WINDOW_ID?: number;
  docfilters?: string;
  tablename?: string;
  taggedcolumns?: string;
  value?: string;
}

export interface TreeMaintenanceTableDefinition {
  tableId?: number;
  tableName?: string;
  treeId?: number;
  treeType?: string;
}

export interface UINotificationsWS {
  nbAlerts?: number;
  nbChats?: number;
  nbNotifs?: number;
}

export interface UserRoleData {
  ad_Client_ID?: number;
  ad_Role_ID?: number;
  ad_User_ID?: number;
  isActive?: string;
  roleName?: string;
}

/**
 * Complete customer 360 response data combining all views
 */
export interface View360Response {
  actionsBadge?: BadgeData;
  cbpartnerId?: number;
  currency?: string;
  customerProfile?: CustomerProfileData;
  expeditionsBadge?: BadgeData;
  invoicesBadge?: BadgeData;
  lastRefresh?: Date;
  mtdEarnings?: EarningsStatistics;
  offers?: CountStatistics;
  opportunities?: CountStatistics;
  ordersBadge?: BadgeData;
  paymentAverageDays?: number;
  paymentsBadge?: BadgeData;
  top?: number;
  ytdEarnings?: EarningsStatistics;
}

export interface WorkflowExecutionMessage {
  workflow?: RunWorkFlow;
  workflowId?: string;
}

export interface ZoomInfo {
  colValues?: Record<string, any>;
  recordId?: string;
  request?: GridRowsRequest;
  tableNameTargeted?: string;
  zoomType?: string;
  zoomTypeId?: number;
  zoomUrl?: string;
}

export enum AggFunc {
  AVG = "avg",
  COUNT = "count",
  MAX = "max",
  MIN = "min",
  SUM = "sum",
}

export enum ArkhineoTaskStatus {
    PENDING = "PENDING",
    PROCESSING = "PROCESSING",
    FAILED = "FAILED",
}

export enum DroolsNewFileRequestType {
  Folder = "folder",
  File = "file",
}

export enum EntityStateType {
  FIELD = "field",
  TAB = "tab",
  PROCESS_PARAM = "process-param",
  FORM_DETAIL_ITEM = "form-detail-item",
}

export enum FieldStateErrorCode {
  FIELD_NOT_FOUND = "FIELD_NOT_FOUND",
  INVALID_LOGIC = "INVALID_LOGIC",
  EVALUATION_ERROR = "EVALUATION_ERROR",
  INVALID_REQUEST = "INVALID_REQUEST",
  SQL_ERROR = "SQL_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

export enum FilterType {
  NUMBER = "number",
  TEXT = "text",
  DATE = "date",
  TIME = "time",
  NONE = "none",
  SET = "set",
}

export enum ItemStateType {
  MANDATORY = "mandatoryLogic",
  READONLY = "readonlyLogic",
  DISPLAYED = "displayLogic",
  DEFAULT_VALUE = "defaultValue",
}

export enum NumberType {
  AMOUNT = "amount",
  INTEGER = "integer",
  FLOAT = "float",
  QUANTITY = "quantity",
}

export enum Operator {
  LESS = "lessThan",
  LESS_EQUALS = "lessThanOrEqual",
  BIGGER = "biggerThan",
  BIGGER_EQUALS = "biggerThanOrEqual",
  BETWEEN = "between",
  CONTAINS = "contains",
  NOT_CONTAINS = "notContains",
  EQUALS = "equals",
  NOT_EQUALS = "notEqual",
  STARTS_WITH = "startsWith",
  ENDS_WITH = "endsWith",
  IS_NULL = "isNull",
  IS_NOT_NULL = "isNotNull",
}

export enum QuickActionType {
  NEWRECORD = "NEWRECORD",
  PROCESS = "PROCESS",
}

export enum RunWorkflowStatus {
  QUEUED = "QUEUED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export enum StatisticsCardType {
  NORMAL = "NORMAL",
  COUNT = "COUNT",
}

export enum WindowType {
  WINDOW = "W",
  FORM = "F",
  SEARCH_WINDOW = "S",
  TABLE = "T",
}
